import React from "react";
import { Link } from "react-router-dom";
import { Quotation } from "features/Quotations/types/quotation.types";
import { getClientDisplayName } from "features/Clients/utils/clientDisplayName";
import { ClientPopover } from "components/common/ClientPopover";

export function clientLine(record: Quotation): React.ReactNode {
  if (record.clientId != null && record.client) {
    const name = getClientDisplayName(record.client);
    return (
      <ClientPopover client={record.client} clientId={record.clientId}>
        <Link to={`/clients/${record.clientId}`} className="link fw-medium">
          {name !== "—" ? name : record.client.email || "—"}
        </Link>
      </ClientPopover>
    );
  }
  return "—";
}
